import 'ckeditor5/ckeditor5-content.css';
import './editor-viewer.scss';

import { cn } from '@core/utils';

/**
 * XSS 공격 방지를 위한 HTML sanitize 함수
 * - <script> 태그 제거
 * - onclick, onerror 등 이벤트 핸들러 속성 제거
 * - javascript: 프로토콜 제거
 */
const sanitizeHtml = (html: string): string => {
  return html
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    .replace(/\s+on\w+\s*=\s*["'][^"']*["']/gi, '')
    .replace(/\s+on\w+\s*=\s*[^\s>]+/gi, '')
    .replace(/javascript:/gi, '');
};

interface EditorViewerProps {
  content: string;
  style?: React.CSSProperties;
  className?: string;
}

export const EditorViewer = ({
  content,
  style,
  className,
}: EditorViewerProps) => {
  return (
    <div
      style={style}
      className={cn('ck-content min-h-54 text-left text-Gray-black', className)}
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }}
    />
  );
};
